import { SVGAttributes } from "react";
const SvgLoader3Fill = (props: SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3.055 13H5.07a7.002 7.002 0 0013.858 0h2.016a9.001 9.001 0 01-17.89 0zm0-2a9.001 9.001 0 0117.89 0H18.93a7.002 7.002 0 00-13.858 0H3.055z" />
  </svg>
);
export default SvgLoader3Fill;
